<style lang="less">
.voices-form {
  .el-form-item__content {
    .hide {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .el-upload-list__item-name {
      max-width: 150px;
    }
  }
}
    .el-upload-list__item {
      transform: none !important;
    }
    .el-upload-list__item:first-child {
      margin-top: 0;
    }
    .avatar-uploader /deep/ .el-upload-list__item {
      transition: none !important;
    }
    .el-list-leave-active {
      transition: none !important;
    }
    .el-list-enter-active {
        transition: none !important;
      }
</style>
<template>
  <el-card>

    <div class="form-container">
      <el-form ref="form" :model="form" :rules="rules" label-width="110px" v-loading="loading">
        <el-form-item label="产品名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="产品关键词" prop="keyword">
          <el-input type="textarea" v-model="form.keyword" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="产品分类" prop="productCateId">
          <el-select v-model="form.productCateId" placeholder="请选择" @change="getAttributes">
            <el-option :label="item.name" :value="item.id" v-for="(item, index) in cates" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品属性" prop="attributes" style="width:80%">
          <el-checkbox-group v-model="checkedAttributes">
            <el-checkbox :label="item.id" name="attributes" v-for="(item, index) in attributes"
                         :key="index">{{item.value}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="产品系列" prop="series_id" style="width:80%">
          <el-radio-group v-model="form.series_id">
            <el-radio :label="item.id" v-for="(item, index) in series"
                         :key="index">{{item.title}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="产品功能" style="width:80%">
          <el-checkbox-group v-model="form.feature_ids">
            <el-checkbox :label="item.id" v-for="(item, index) in features"
                         :key="index">{{item.keyword}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="产品标签">
          <el-checkbox v-model="form.hot">热卖</el-checkbox>
          <el-checkbox v-model="form.newset">新品</el-checkbox>
        </el-form-item>
        <!-- <el-form-item label="产品参数模版">
          <el-select placeholder="请选择" @change="templatesChange">
            <el-option :label="item.name" :value="item.id" v-for="(item, index) in templates" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品参数">
            <el-form ref="forms" inline :model="item" :rules="rules" v-for="(item, index) in form.attrs" :key="index" >
              <div style="display:flex;flex-direction:row;margin-bottom:20px;" >
                <el-form-item prop="attrName" style="width:200px;padding:0">
                  <el-input placeholder="产品参数名称" v-model="item.attrName"></el-input>
                </el-form-item>
                <el-form-item prop="attrValue" style="width:200px;padding:0">
                  <el-input placeholder="产品参数内容" v-model="item.attrValue"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-link type="danger" @click="removeAttrsItem(item, index)">删除</el-link>
                </el-form-item>
              </div>
            </el-form>
            <el-button type="text" @click="addAttrsItem">添加产品参数</el-button>
        </el-form-item> -->
        <el-form-item label="产品音频" style="width:100%">
          <el-form inline :model="item" :rules="rules" v-for="(item, index) in form.voices" :key="index" >
            <div style="display:flex;flex-direction:row;margin-bottom:20px;" class="voices-form" >
              <el-form-item label="" style="width:200px !important;min-width:200px;" >
                <el-input placeholder="音频名称" v-model="item.name"></el-input>
              </el-form-item>
              <el-form-item label="" style="min-width:auto;width:300px;">
                <uploader :file-list="item.url ? [{ url: item.fullPath, name: item.url }] : []" target="upload" :params="{folder:'music-score',type:'audio'}" @success="(res) => successVoices(res, index)" @remove="removeVoices(index)" showFileList :limit="1" accept="audio/*">
                  <el-button size="small" type="primary">点击上传</el-button>
                </uploader>
              </el-form-item>
              <el-form-item>
                <el-button v-if="form.voices.length > 1" type="text" @click="removeVoicesItem(item, index)" style="color:#F56C6C">删除</el-button>
              </el-form-item>
            </div>
          </el-form>
             <el-button type="text" @click="addVoicesItem">添加产品音频</el-button>
        </el-form-item>

        <el-form-item label="产品价格" prop="price">
          <el-input v-model="form.price" placeholder="请输入" type="number" />
        </el-form-item>
        <el-form-item label="主图上传" prop="mainFileId">
          <el-upload :action="uploadPath" list-type="picture-card"
                     :auto-upload="true" :headers="headers"
                     :on-success="handleCoverSuccess"
                     :data="uploadCoverParam"
                     accept=".jpg,.jpeg,.png,.gif,.svg"
                     :beforeUpload="beforeCoverUpload"
                     :on-error="handleUploadError"
                     :limit="1" :file-list="coverList">
            <i class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}">
              <img
                class="el-upload-list__item-thumbnail"
                :src="file.url" alt=""
              >
              <span class="el-upload-list__item-actions">
              <span
                class="el-upload-list__item-preview"
                @click="coverPreview(file)"
              >
                <i class="el-icon-zoom-in"></i>
              </span>
              <span
                class="el-upload-list__item-delete"
                @click="handleCoverRemove(file)"
              >
                <i class="el-icon-delete"></i>
              </span>
            </span>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="轮播图上传" style="width:100%">
          <el-upload :action="uploadPath" list-type="picture-card"
                     :auto-upload="true" :headers="headers"
                     :on-success="handleImagesSuccess"
                     :data="uploadBannerParam"
                     accept=".jpg,.jpeg,.png,.gif,.svg,.mp4"
                     :beforeUpload="beforeCoverUpload"
                     :on-remove="handleImageRemove"
                     :on-error="handleUploadError"
                     :on-preview="coverPreview"
                     :limit="100" :file-list="bannersList">
            <i class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}">
              <img
                class="el-upload-list__item-thumbnail"
                :src="file.mediaType == 'image' ? file.url : '/img/video.36d548fd.jpg'" alt=""
              >
              <span class="el-upload-list__item-actions">
              <span
                class="el-upload-list__item-preview"
                @click="coverPreview(file)"
              >
                <i class="el-icon-zoom-in"></i>
              </span>
              <span
                class="el-upload-list__item-delete"
                @click="handleImageRemove(file)"
              >
                <i class="el-icon-delete"></i>
              </span>
            </span>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="图文详情：" prop="photo_url" label-width="110px">
            <desc-view :form.sync="form" @selectChange="descChange" />
          </el-form-item>

        <el-form-item class="buttons">
          <el-button type="primary" @click="submitForm">立即创建</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </el-card>
</template>

<script>
  import store from '@/store'
  import _ from 'lodash'
  import descView from './components/desc'

  export default {
    components: {
      'desc-view': descView,
    },
    data() {
      return {
        templates: [],
        series: [],
        features: [],
        loading: true,
        isEdit: false,
        dialogVisible: false,
        dialogImageUrl: '',
        disabledCover: false,
        cates: [],
        coverList: [],
        bannersList: [],
        uploadCoverParam: {
          folder: 'product-cover',
          type: 'image'
        },
        uploadBannerParam: {
          folder: 'product-banners'
        },
        attributes:[],
        checkedAttributes:[],
        form: {
          name: '',
          keyword: '',
          productCateId: '',
          mainFileId: '',
          description: '',
          attributes:[],
          price: '',
          series_id: '',
          feature_ids: [],
          attrs: [],
          voices: [],
          desc: [],
          banners: []
        },
        rules: {
          name: this.$formHelper.requiredRuleFactory('请填写产品名称'),
          price: this.$formHelper.requiredRuleFactory('请输入产品价格'),
          // attrName: this.$formHelper.requiredRuleFactory('请填写产品参数名称'),
          // attrValue: this.$formHelper.requiredRuleFactory('请填写产品参数内容'),
          attributes: [{ required: true, message: '请勾选产品属性', trigger: 'blur' }],
          series_id: [{ required: true, message: '请勾选产品系列', trigger: 'blur' }],
          productCateId: [{ required: true, message: '请选择产品分类', trigger: 'blur' }],
          mainFileId: [{ required: true, message: '产品主图必须上传', trigger: 'blur' }],
          description: [{ required: true, message: '产品详情必须上传', trigger: 'blur' }],
        },
      }
    },
    computed: {
      uploadPath() {
        return this.$config.api.baseURL + '/upload'
      },
      headers() {
        const { token } = store.state.auth
        return {
          'Authorization': `Bearer ${token}`
        }
      },
    },
    watch: {
      checkedAttributes(newValue, oldValue) {
        const attributes = [];
        newValue.forEach((item, index) => {
          attributes.push({ attributeId : item})
        })
        this.form.attributes = attributes
      },
    },
    methods: {
      addVoicesItem() {
        let form = _.cloneDeep(this.form)
        form.voices.push({})
        this.form = form
      },
      removeVoicesItem(item, index) {
        let form = _.cloneDeep(this.form)
        form.voices.splice(index, 1)
        this.form = form
      },
      successVoices(res, index) {
        if (res) {
          let form = _.cloneDeep(this.form)
          form.voices[index] = {
            ...form.voices[index],
            url: res.url,
            fullPath: res.url
          }
          this.form = form
        }
        this.loading = false
      },
      removeVoices(index) {
        let form = _.cloneDeep(this.form)
        delete form.voices[index].url
        delete form.voices[index].fullPath
      },
      // removeAttrsItem(item, index) {
      //   let form = _.cloneDeep(this.form)
      //   form.attrs.splice(index, 1)
      //   this.form = form
      // },

      // addAttrsItem() {
      //   let form = _.cloneDeep(this.form)
      //   form.attrs.push({})
      //   this.form = form
      // },
      // templatesChange(templateId) {
      //   const template = this.templates.find(item => {
      //     return item.id == templateId
      //   })

      //   if (template && template.attrNames && template.attrNames.length) {
      //     let attrs = []
      //     for (let i = 0; i < template.attrNames.length; i++) {
      //       attrs.push({ attrName: template.attrNames[i], attrValue: '' })
      //     }
      //     if (!attrs.length) {
      //       attrs = [{}]
      //     }
      //     let form = _.cloneDeep(this.form)
      //     form.attrs = attrs
      //     this.form = form
      //   }
      // },
      descChange(desc) {
        let form = { ...this.form }
        form.desc = desc
        this.form = form
      },
      async getAttributes(isSetEmpty = true) {
        if(isSetEmpty) {
          this.checkedAttributes = []
          let form = { ...this.form }
          form.series_id = ''
          this.form = form
        }
        const queryParam = {
          query: { productCateId: this.form.productCateId },
          pagination:{ limit: 20 }
        }
        const { collection } = await this.$store.dispatch('attributes/collection', queryParam)
        this.attributes = collection

        const series = await this.$store.dispatch('series/allCollection', {
          query: {
            product_cate_id: this.form.productCateId
          }
        })
        if (series && series.collection && series.collection.length) {
          this.series = series.collection
        }
      },
      async init() {
        const queryParam = {
          query: {},
          pagination:{ limit: 20 }
        }
        const { collection } = await this.$store.dispatch('productCates/collection', queryParam)
        this.cates = collection

        const features = await this.$store.dispatch('features/allCollection')
        if (features && features.collection && features.collection.length) {
          this.features = features.collection
        }

        const templates = await this.$store.dispatch('templates/allCollection')
        if (templates && templates.collection && templates.collection.length) {
          this.templates = templates.collection
        }


        const { id } = this.$route.query
        if(id) {
          this.isEdit = true
          const { document } = await this.$store.dispatch('products/document', id)

          this.coverList = [{name: document.mainFileId, url: document.mainFileUrl}]
          this.detailsList = document.detailFileUrls

          document.attributes.forEach((item, index) => {
            this.checkedAttributes.push(item.attributeId)
          })
          const { keyword, name, productCateId, mainFileId, description, attributes, price, feature_ids = [], series_id = '', banners = [], hot = false, newset = false, attrs = [{}], voices = [{}] } = _.cloneDeep(document)
          let bannersList = []
          let newBanners = []
          banners.forEach(item => {
            bannersList.push({ name: item.path, url: item.fullPath, mediaType: item.mediaType})
            newBanners.push({ path: item.path, id: item.id, mediaType: item.mediaType })
          })
          this.bannersList = bannersList

          let newVoices = []
          voices.forEach(item => {
            newVoices.push({ url: item.url, fullPath: item.fullPath, name: item.name, id: item.id })
          })
          this.form = { attrs,keyword, id, name, productCateId, mainFileId, description, attributes, price, feature_ids, series_id, banners: newBanners, hot, newset, voices: newVoices,desc: description }
          this.getAttributes(false)
        }
        this.loading = false
      },
      //产品主图上传
      beforeCoverUpload(file) {
        if (file.type.indexOf('mp4') > 0) {
          const isLt4M = file.size / 1024 / 1024 <= 50
          if(!isLt4M) {
            this.$message.warning("视频大小不能超过50M")
            return false
          }
        } else {
          const isLt4M = file.size / 1024 / 1024 <= 50
          if(!isLt4M) {
            this.$message.warning("图片大小不能超过50M")
            return false
          }
        }

        this.loading = true
      },
      handleCoverSuccess(res, file, fileList) {
        this.coverList = fileList
        this.form.mainFileId = res.data.path
        this.loading = false
      },
      handleCoverRemove() {
        this.coverList = []
        this.form.mainFileId = ''
      },
      handleImagesSuccess(res, file, fileList) {
        if (res && res.data) {
          let bannersList = this.bannersList ? [...this.bannersList] : []
          console.log(bannersList)
          bannersList.push({
            name: res.data.path,
            url: res.data.url,
            mediaType: res.data.type
          })
          this.bannersList = bannersList

          let form = _.cloneDeep(this.form)
          form.banners.push({
            path: res.data.path,
            mediaType: res.data.type
          })
          this.form = form
        }
        this.loading = false
      },
      handleImageRemove(file) {
        const url = file.url
        const name = file.name
        const bannersList = this.bannersList.filter(item => {
          return item.url != url
        })
        this.bannersList = bannersList
        let form = _.cloneDeep(this.form)
        form.banners = form.banners.filter(item => {
          return item.path != name
        })
        this.form = form
      },
      coverPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handleUploadError(res) {
        this.$message.error(JSON.parse(res.message).message)
        this.loading = false
      },
      async submitForm() {
        await this.$formHelper.promisedValidate(this.$refs.form)
        this.loading = true
        let formData = _.cloneDeep(this.form)
        let voices = []
        for (let i = 0; i < formData.voices.length;i++) {
          const item = formData.voices[i]
          if ((!item.url && item.name) || (item.url && !item.name)) {
            this.loading = false
            this.$message.error('请完善产品音频')
            return
          }

          if (item.url && item.name) {
            const voice = {
              url: item.url,
              name: item.name
            }
            if (item.id) voice.id = item.id
            voices.push({ ...voice})
          }
        }
        formData.voices = voices
        if (formData.desc && formData.desc.length) {
          formData.description = formData.desc
        } else {
          formData.description = []
        }
        delete formData.desc

        if(this.isEdit) {
          await this.$store.dispatch('products/replace', formData)
          // this.loading = false
          // this.$message.success('编辑产品成功')
        } else {
          await this.$store.dispatch('products/create', formData)
          this.loading = false
          this.$message.success('添加产品成功')
        }
        this.$router.push('/product/list')
      },
      async uploadFile(file, callback) {
        this.loading = true
        const { path, url } = await this.$store.dispatch('upload/upload', { file, path: 'product-detail', folder:
            'product-detail'})
        callback(url, path)
        this.loading = false
      }
    },
    async mounted() {
      this.init()
    }
  }
</script>
